import { render, staticRenderFns } from "./slideDialog.vue?vue&type=template&id=084be0a7&scoped=true"
import script from "./slideDialog.vue?vue&type=script&lang=js"
export * from "./slideDialog.vue?vue&type=script&lang=js"
import style0 from "./slideDialog.vue?vue&type=style&index=0&id=084be0a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084be0a7",
  null
  
)

export default component.exports